module.exports = __webpack_public_path__ + "static/media/CAMARONPLANCHA_MENU-normal.5d672de0.png";